module.exports = __webpack_public_path__ + "img/people_zw.1dfde41e.png";